import { BaseAuthContext } from '@common/Login/typing'

export const defaultAuthContext: BaseAuthContext<any> = {
  user: null,
  isLoggedIn: false,
  login: async () => {},
  loginError: null,
  logout: async () => {},
  authorize: async () => ({ login: false, stopNavigate: false }),
}
